import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/auth.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

	constructor(private authService: AuthenticationService) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		// ✅ Lee el token desde el signal del AuthenticationService
		const token = this.authService.getHeaders().headers.get('Authorization');

		if (token) {
			request = request.clone({
				setHeaders: {
					Authorization: `${token}`
				}
			});
		}
		else {
			console.log('No token found');
		}

		return next.handle(request);
	}
}